<template>
  <div class="footer_infos u-align--center">

    <span>
      <copyrightYear v-pre>2019</copyrightYear>
      <a target="_blank" href="https://sfdermato.org/" itemprop="creator"> <abbr title="Société
        Française de Dermatologie et de Pathologie Sexuellement Transmissible">SFD</abbr>
        <img src="@/assets/img/icons.svg#icon-external-link-white" width="8" height="8">
      </a>
      <router-link to="/info/mentions-legales" @click.native="$scrollToTop">Mentions légales &amp; Politique de confidentialité</router-link>
      <router-link to="/info/cgu" @click.native="$scrollToTop"><attr title="Conditions générales d'utilisation"  v-pre>CGU</attr></router-link>
      <router-link to="/info/plan-du-site" @click.native="$scrollToTop">Plan du site</router-link>
    </span>
  </div>
</template>

<script>

  export default {
    name: 'v-footer',
    data: () => {
      return {
      }
    }
  }
</script>

<style lang="scss">
  .footer_infos {
    color: #444;
    padding: rem(28px) 0;
    font-size: rem(14px);
    line-height: rem(24px);

    copyrightYear::before{content:"©"}

    a {
      color: #444;
      text-decoration: none;

      & + a::before {content:"-";margin:0 .66em}

    }

    abbr {margin-left:.33em}

    abbr + img {margin-left:.2em;vertical-align:text-top}

    @include mq($until: MD) {
      padding: rem(11px) rem(20px) rem(15px);
      font-size: rem(12px);
      line-height: rem(18px);

      a 		{display:block;width:100%;text-align:center;padding:1em;font-size:1.4em}
      a + a 	{border-top:1px solid #D3D3D3}
      a::before {content:"";display:none}

      abbr::before {content:"© 2019 "}

      copyrightYear,
      a img {display:none}

    }


  }

</style>
